import type { CompProps, GenericFieldConfig } from '@neo/blocks/forms/types'
import { Alert } from '@neo/primitives/alert'
import { FlowTypes } from 'v2/types'
import { AudioPrompt } from '../components/audio-prompt'
import { v2validations } from '../config/validation.config'
import { useStartNodeType } from '../hooks/use-start-node-type'
import type { CustomerFeedbackNodeData, SidebarComponentProps } from '../types'
import { GenericSidebarComponent } from './sidebar.base'

type FormValues = CustomerFeedbackNodeData['config']

const fields = (nodeVars: string[], type: FlowTypes): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).customer_feedback
  return [
    {
      name: 'name',
      label: 'Name',
      zodValidation: validations.shape.name,
      componentType: 'input',
      inputProps: {
        type: 'text',
      },
    },
    {
      name: 'input_timeout',
      label: 'Input Timeout',
      zodValidation: validations.shape.input_timeout,
      componentType: 'inputNumber',
      visible: type === FlowTypes.incoming_call || type === FlowTypes.outgoing_call,
      inputProps: {
        type: 'number',
      },
    },
    {
      name: 'interrupt',
      label: 'Interrupt audio on input',
      componentType: 'checkbox',
      visible: type === FlowTypes.incoming_call || type === FlowTypes.outgoing_call,
      zodValidation: validations.shape.interrupt,
    },
    {
      name: 'delay',
      label: 'Wait time before Prompt',
      zodValidation: validations.shape.delay,
      componentType: 'inputNumber',
      visible: type === FlowTypes.incoming_call || type === FlowTypes.outgoing_call,
      inputProps: {
        type: 'number',
      },
    },
    {
      name: 'prompt',
      label: 'Prompt',
      type: 'custom',
      visible: type === FlowTypes.incoming_call || type === FlowTypes.outgoing_call,
      component: (props) => (
        <AudioPrompt
          {...(props as CompProps<FormValues, FormValues['prompt']>)}
          nodeVars={nodeVars}
        />
      ),
      zodValidation: validations.shape.prompt,
      eventDataExtractor: (data) => data as Record<string, unknown>,
    },
    {
      name: 'message',
      label: 'Message',
      type: 'sub-item',
      visible: false,
      // type === FlowTypes.incoming_chat || type === FlowTypes.incoming_whatsapp,
      componentType: 'textarea',
      zodValidation: validations.shape.message,
    },
    {
      name: 'alert info',
      type: 'slot',
      component: (
        <Alert
          variant="warning"
          className="border-0 col-span-2"
          content={
            <span>
              Rating scale is set between{' '}
              <span className="font-jetbrains text-xs-500">1 [lowest]</span> to{' '}
              <span className="font-jetbrains text-xs-500">5 [highest]</span> by default
            </span>
          }
        />
      ),
    },
  ]
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const CustomerFeedbackSidebarComponent = (
  props: SidebarComponentProps<CustomerFeedbackNodeData>,
) => {
  const { nodeVars } = props
  const type = useStartNodeType()
  const formFields = fields(nodeVars, type as FlowTypes)

  return <GenericSidebarComponent fields={formFields} {...props} />
}
